import React from "react";
import PropTypes from "prop-types";
import { HiOutlineLockClosed } from "react-icons/hi";

function TreasurePrompt({ open, place, onConfirm, onCancel }) {
  if (!open) return null;

  // 只關閉提示，不清除地點
  const handleCancel = () => {
    console.log("[藏寶提示] 按下取消");
    if (onCancel) onCancel();
  };

  return (
    <div className="fixed bottom-0 left-0 w-full z-[99999] flex justify-center pointer-events-none">
      <div className="pointer-events-auto w-full max-w-md mx-auto bg-neutral-900 rounded-t-3xl shadow-2xl border-t border-neutral-800 p-5 mb-0 flex flex-col items-center animate-fadeIn font-sans">
        <div className="flex items-center gap-3 mb-3">
          <span className="inline-flex items-center justify-center w-10 h-10 bg-amber-400 rounded-full shadow">
            <HiOutlineLockClosed className="text-neutral-900 text-2xl" />
          </span>
          <span className="text-lg font-bold text-white tracking-wide drop-shadow-sm">
            確認在此藏寶？
          </span>
        </div>
        {/* {place && (
          <div className="flex items-center gap-2 mb-4 text-sm text-amber-200">
            <HiOutlineLocationMarker className="text-amber-400 text-lg" />
            <span className="font-medium truncate max-w-[180px]">
              {place.name || "自定義地點"}
            </span>
          </div>
        )} */}
        <div className="flex gap-4 w-full mt-1">
          <button
            className="flex-1 px-0 py-2 rounded-xl bg-amber-400 text-neutral-900 font-bold shadow-lg hover:bg-amber-500 transition text-lg focus:outline-none focus:ring-2 focus:ring-amber-300"
            onClick={onConfirm}
          >
            確認
          </button>
          <button
            className="flex-1 px-0 py-2 rounded-xl bg-neutral-800 text-white font-bold shadow hover:bg-neutral-700 transition text-lg focus:outline-none focus:ring-2 focus:ring-neutral-500"
            onClick={handleCancel}
          >
            取消
          </button>
        </div>
      </div>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: none; } }
        .animate-fadeIn { animation: fadeIn 0.3s ease; }
      `}</style>
    </div>
  );
}

TreasurePrompt.propTypes = {
  open: PropTypes.bool.isRequired,
  place: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default TreasurePrompt;
